import ToastContainer from "../../../Components/BonusUi/Toast/Toast"

const Toast = () => {
  return (
    <div className='page-body'>
      <ToastContainer />
    </div>
  )
}

export default Toast